import { StageInterface } from "@/v2/types/StageInterface";

const calculateStageCompletion = (stage: StageInterface) => {
  if (stage.counts.total === 0) return 0;

  return Math.round((stage.counts.settled / stage.counts.total) * 100);
};

export default calculateStageCompletion;
